export * from "./setting.entity";
